var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTimeCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ED1B2E"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M26.583 14.5c0 6.675-5.41 12.084-12.084 12.084-6.673 0-12.083-5.409-12.083-12.084 0-6.672 5.41-12.083 12.083-12.083 6.674 0 12.084 5.41 12.084 12.083z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.818 19.109a.913.913 0 01-.464-.127l-4.744-2.83a.91.91 0 01-.441-.78V9.275a.907.907 0 011.812 0v5.584l4.302 2.565a.908.908 0 01-.465 1.686z"
  }))));
}

export default SvgIconTimeCircle;